import React, { useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const CreateNewCompany = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [companyData, setCompanyData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    function: "",
    language: "French",
    phone: "",
    companyName: "",
  });

  const [provisionalAmount] = useState("0,54 € HT");

  const handleInputChange = (field, value) => {
    setCompanyData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCreateCompany = () => {
    // Logique de création ici
    console.log("Nouvelle société :", companyData);
    navigate("/company");
  };

  return (
    <div className="client-form-container">
      <div className="form-section p-3">
        <div className="step-description p-5">
          <div className="form-group">
            <label>Informations</label>

            <div className="input-row">
              <input
                placeholder="Nom de la société"
                type="text"
                value={companyData.companyName}
                onChange={(e) =>
                  handleInputChange("companyName", e.target.value)
                }
              />
            </div>

            <div className="input-row">
              <input
                placeholder="Entrer l'adresse e-mail"
                type="email"
                value={companyData.email}
                onChange={(e) => handleInputChange("email", e.target.value)}
              />
            </div>

            <div className="input-row">
              <input
                placeholder="Entrer le prénom"
                type="text"
                value={companyData.firstName}
                onChange={(e) => handleInputChange("firstName", e.target.value)}
              />
            </div>

            <div className="input-row">
              <input
                placeholder="Entrer le nom"
                type="text"
                value={companyData.lastName}
                onChange={(e) => handleInputChange("lastName", e.target.value)}
              />
            </div>

            <div className="input-row">
              <label>Fonction</label>
              <input
                type="text"
                value={companyData.function}
                onChange={(e) => handleInputChange("function", e.target.value)}
              />
            </div>

            <div className="input-row">
              <label>Langue</label>
              <select
                value={companyData.language}
                onChange={(e) => handleInputChange("language", e.target.value)}
              >
                <option value="French">Français</option>
                <option value="English">English</option>
                <option value="Spanish">Español</option>
              </select>
            </div>
          </div>

          <div className="divider"></div>

          <div className="form-group">
            <label>Coordonnées de la société</label>
            <div className="input-row">
              <input
                placeholder="Entrez le numéro de téléphone"
                type="tel"
                value={companyData.phone}
                onChange={(e) => handleInputChange("phone", e.target.value)}
              />
            </div>
          </div>

          <div className="form-actions mt-4">
            <button
              type="button"
              className="create-company-btn"
              onClick={handleCreateCompany}
            >
              Créer la société
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewCompany;
